import { SINGLES, W, W_LIVE, HYD_LABEL, HYD_WHY, SEA_MOSS_TAGLINE, SEA_MOSS_IODINE } from "@/data/singles";
import { L_FISH, L_SEAMOSS, L_MULTI, C_EPA, C_DHA, C_SEA, C_VIT, C_B, W_SEA, W_MULTI, FDA_TXT, WHY_FISH, WHY_SEA, WHY_MULTI } from "@/data/ocean";

const S = (id) => SINGLES[id];
const label = (id) => S(id).labels[0];
const why = (id) => S(id).why.replace(` ${FDA_TXT}`, "");
const W_FISH = "Contains fish (sardines, anchovies). Consult your doctor before use if you take blood-thinning medication.";
const W_D3 = "Contains soybean oil. Also contains corn oil and gelatin (softgel).";

const C_INULIN = "Inulin is a prebiotic fibre that feeds beneficial gut bacteria.*";
const C_ENZ = "Digestive enzymes support the normal breakdown of food.*";
const C_PRO = "Probiotics support digestive health and a healthy balance of gut flora.*";
const C_MG = "Magnesium supports normal muscle and nerve function.*";
const C_D = "Vitamin D supports normal calcium absorption and healthy bones.*";
const C_COL = "Collagen protein supports healthy skin as part of a balanced diet.*";

const L_GUT = label("gut-health");
const L_PRO = label("probiotic-20b");
const L_MG = label("magnesium-glycinate");
const L_D3 = label("vitamin-d3");
const L_COL = label("collagen");
const L_GREENS = { name: "Greens Superfood powder (126 g)", text: `Supplement Facts
Serving Size: 1 Scoop (4.2 g)
Servings Per Container: 30
LEFT PANEL                Amount Per Serving   %DV
Calories                  10
Total Carbohydrates       2 g                  1%**
  Dietary Fiber           2 g                  6%**
Greens Blend              2,000 mg             ***
  Barley Grass Powder (leaf), Broccoli Powder (Brassica oleracea) (leaf), Spirulina Powder (Arthrospira platensis) (whole plant), Green Tea Powder (leaf), Alfalfa Extract (whole herb), Wheat Grass (Triticum aestivum L.) (leaf)
Reds Blend                1,500 mg             ***
  Beet Root Powder (Beta vulgaris) (root), Hibiscus Powder (flower), Strawberry Juice Powder (fruit), Cranberry Powder (Vaccinium macrocarpon L.) (fruit), Acai Juice Powder (fruit), Blueberry Extract (berry), Pomegranate Powder (fruit)
RIGHT PANEL               Amount Per Serving   %DV
Metabolic Support Blend   300 mg               ***
  Cinnamon (Cinnamomum cassia) (bark), Turmeric Extract (root), Panax ginseng Powder (root), Ashwagandha Powder (root), Mangosteen Extract (Garcinia Mangostana L.) (pericarp), Black Pepper Extract (fruit)
Digestive Support         200 mg               ***
  Inulin (from Helianthus tuberosus) (root), Ginger Powder (root), Sodium Alginate
**Percent Daily Values are based on a 2,000 calorie diet.
***Daily Value (DV) not established.
Other Ingredients: Citric Acid, Stevia Extract (leaf)
Contains: Wheat` };

const WHY_COL = why("collagen");
const C_GREENS = "Greens powder adds plant-based nutrients that support a balanced morning routine.*";
const C_WELL = "Supports overall wellness as part of a balanced diet.*";
const C_HYD = "Electrolytes (sodium and potassium) support hydration and normal fluid balance.*";
const L_HYD = { name: "Hydration Powder – Lemonade (162 g)", text: HYD_LABEL("10 kcal", "Beta Carotene") };
const L_LY = { name: "Hydration Powder – Lychee (162 g)", text: HYD_LABEL("10 kcal", "Beet Juice Powder") };
const W_HYD = "Do not exceed 5 scoops in 24 hours. Not intended for use by persons with a medical condition. Manufactured in a facility that produces milk, eggs, fish, shellfish, tree nuts, peanuts, wheat, soybeans and sesame.";
const W_GREENS = "Contains: Wheat. Also contains green tea, Panax ginseng, ashwagandha and stevia; consult your doctor if you take medication. Consume within 10 minutes of mixing.";
const WHY_HYD = HYD_WHY.replace(` ${FDA_TXT}`, "");
const WHY_GREENS = "People take greens powders to add greens and plant powders to their day.";

export const BUNDLES = {
  "calm-waters-reset": {
    sku: "GF-STACK-RESET", claims: [C_INULIN, C_ENZ, C_PRO, C_MG], labels: [L_GUT, L_PRO, L_MG],
    warnings: [W, W_LIVE],
    why: `${why("gut-health")} ${why("probiotic-20b")} ${why("magnesium-glycinate")} ${FDA_TXT}`,
  },
  "deep-ocean-essentials": {
    sku: "GF-STACK-DEEP", claims: [C_EPA, C_DHA, C_D, C_VIT, C_B], labels: [L_FISH, L_D3, L_MULTI],
    warnings: [W, `${W_FISH} ${W_D3} ${W_MULTI}`],
    why: `${WHY_FISH} ${why("vitamin-d3")} ${WHY_MULTI} ${FDA_TXT}`,
  },
  "sea-moss-sunshine": {
    sku: "GF-STACK-SUN", claims: [C_SEA, C_D], labels: [L_SEAMOSS, L_D3],
    warnings: [W, `${W_SEA} ${W_D3}`],
    why: `${WHY_SEA} ${why("vitamin-d3")} ${FDA_TXT}`,
  },
  "low-tide-calm": {
    sku: "GF-STACK-LOWTIDE", claims: [C_MG, C_EPA, C_DHA], labels: [L_MG, L_FISH],
    warnings: [W, W_FISH],
    why: `${why("magnesium-glycinate")} ${WHY_FISH} ${FDA_TXT}`,
  },
  "coral-glow": {
    sku: "GF-STACK-CORAL", claims: [C_COL, C_EPA, C_DHA], labels: [L_COL, L_FISH],
    warnings: [W, `Bovine (beef hide) source. ${W_FISH}`],
    why: `${WHY_COL} ${WHY_FISH} ${FDA_TXT}`,
  },
  "reef-gut-balance": {
    sku: "GF-STACK-REEF", claims: [C_PRO, C_SEA, C_INULIN, C_ENZ], labels: [L_PRO, L_SEAMOSS, L_GUT],
    warnings: [W, `${W_LIVE} ${W_SEA}`],
    why: `${why("probiotic-20b")} ${WHY_SEA} ${why("gut-health")} ${FDA_TXT}`,
  },
  "captains-daily-pack": {
    sku: "GF-STACK-CAPTAIN", claims: [C_VIT, C_B, C_EPA, C_DHA, C_MG], labels: [L_MULTI, L_FISH, L_MG],
    warnings: [W, `${W_MULTI} ${W_FISH}`],
    why: `${WHY_MULTI} ${WHY_FISH} ${why("magnesium-glycinate")} ${FDA_TXT}`,
  },
  "kelp-forest-morning-tide": {
    sku: "GF-STACK-MORNING", claims: [C_GREENS, C_WELL, C_EPA, C_DHA, C_D],
    labels: [L_GREENS, L_FISH, L_D3],
    warnings: [W, `Contains: Wheat. Also contains green tea, Panax ginseng, ashwagandha and stevia; consult your doctor if you take medication. Consume within 10 minutes of mixing. ${W_FISH} ${W_D3}`],
    why: `${WHY_GREENS} ${WHY_FISH} ${why("vitamin-d3")} ${FDA_TXT}`,
  },
  "sea-spray-active": {
    sku: "GF-STACK-ACTIVE", claims: [C_HYD, C_B, C_MG], labels: [L_LY, L_MG],
    warnings: [W, W_HYD],
    why: `${WHY_HYD} ${why("magnesium-glycinate")} ${FDA_TXT}`,
  },
  "full-tide-four": {
    sku: "GF-STACK-TRIO", claims: [C_GREENS, C_WELL, C_INULIN, C_ENZ, C_PRO, C_HYD, C_B], labels: [L_GREENS, L_GUT, L_PRO, L_HYD],
    warnings: [W, `${W_GREENS} ${W_LIVE} ${W_HYD}`],
    why: `${WHY_GREENS} ${why("gut-health")} ${why("probiotic-20b")} ${WHY_HYD} ${FDA_TXT}`,
  },
  "captains-daily-duo": {
    sku: "GF-VIP-DUO", claims: [C_EPA, C_DHA, C_VIT, C_B], labels: [L_FISH, L_MULTI],
    warnings: [W, `${W_FISH} ${W_MULTI}`],
    why: `${WHY_FISH} ${WHY_MULTI} ${FDA_TXT}`,
  },
  "gut-and-glow": {
    sku: "GF-VIP-GUTGLOW", claims: [C_PRO, C_INULIN, C_ENZ], labels: [L_PRO, L_GUT],
    warnings: [W, W_LIVE],
    why: `${why("probiotic-20b")} ${why("gut-health")} ${FDA_TXT}`,
  },
  "full-tide-captains-pack": {
    sku: "GF-VIP-FULLTIDE", claims: [C_EPA, C_DHA, C_VIT, C_B, C_PRO], labels: [L_FISH, L_MULTI, L_PRO],
    warnings: [W, `${W_FISH} ${W_MULTI} ${W_LIVE}`],
    why: `${WHY_FISH} ${WHY_MULTI} ${why("probiotic-20b")} ${FDA_TXT}`,
  },  "fish-oil-2-pack": {
    sku: "GF-FISHOIL-2PK", tagline: "Twice the softgels, half the reordering.",
    about: "Two bottles of Grandpa Finn's Omega-3 Fish Oil, 200 softgels in total, so the cupboard stays stocked between swells. Each softgel provides 1,000 mg fish oil concentrate with EPA 180 mg and DHA 120 mg, from sardines and anchovies. Omega-3 EPA & DHA to support overall health.* Take 1 softgel twice daily with meals; each bottle is a 50-day supply. Keep one bottle at home and one in the van, or share with the family.",
    bullets: ["2 x 100 softgels; 1 softgel per serving, 100 softgels per bottle (50-day supply at 2 a day)", "EPA 180 mg + DHA 120 mg per serving. Omega-3s support joint health.*", "Omega-3 DHA supports brain health.*"],
    claims: ["Omega-3 EPA & DHA to support overall health.*", "Omega-3s support joint health.*", "Omega-3 DHA supports brain health.*"],
    research: [
      { text: "The NIH Office of Dietary Supplements explains that EPA and DHA are found in fish and seafood, that the body converts only very small amounts of plant ALA into them, and that the FDA suggests no more than 5 g/day of EPA plus DHA from supplements.", label: "ODS Omega-3 Fact Sheet for Consumers", url: "https://ods.od.nih.gov/factsheets/Omega3FattyAcids-Consumer/" },
      { text: "In a 4-week crossover trial in 24 healthy adults, 600 mg/day omega-3s from fish oil raised red blood cell EPA + DHA compared with a corn-oil control (krill oil raised them more). A short blood-level study; it did not test health outcomes.", label: "PubMed 24304605", url: "https://pubmed.ncbi.nlm.nih.gov/24304605/" },
    ],
    labels: [L_FISH], warnings: [W, "Contains fish (sardines, anchovies). Consult your doctor if pregnant, nursing, on blood thinners or taking medication."],
    meet: "Grandpa Finn, a seventy-something surfer who's paddled out since '67, keeps one bottle by the kettle and one in the van. (Grandpa Finn is a fictional character.)",
  },
  "sea-moss-2-pack": {
    sku: "GF-SEAMOSS-2PK", tagline: SEA_MOSS_TAGLINE,
    about: "Two bottles of Grandpa Finn's Sea Moss capsules, 120 capsules in total, 60 days at two capsules a day. Each serving combines Irish moss (Chondrus crispus) 500 mg, bladderwrack (Fucus vesiculosus) 500 mg and burdock root 400 mg, with 5 mg BioPerine black pepper extract, in pullulan capsules. Grandpa Finn has walked past these seaweeds on the rocks since '67. Keep one bottle at home and one in the van.",
    bullets: ["2 x 60 capsules; 2 capsules per serving, 30 servings per bottle", "Irish moss, bladderwrack and burdock root, plus BioPerine black pepper extract", "Pullulan (plant-based) capsules"],
    claims: [],
    labels: [L_SEAMOSS], warnings: [W, SEA_MOSS_IODINE],
    meet: "Grandpa Finn, a seventy-something surfer who's paddled out since '67, has been stepping over bladderwrack on the reef for longer than most of his mates have been alive. (Grandpa Finn is a fictional character.)",
  },
};
